<template>
  <div class="animated fadeIn text-center">
    <b-row>
      <b-col class="col-xl-12 col-md-12 align-self-center mt-3">
        <strong class="title">HTTP 메소드 제어</strong>
        <b-form-group class="float-right mr-3">
          <div class="checkbox-switch">
            <input type="checkbox" class="input-checkbox" name="switch06" id="switch06" label variant="pill" size="sm" defaultChecked v-model="use_method" @change="change_use_method" :disabled="method_lock">
            <div class="checkbox-animate disabled">
              <span class="checkbox-off">OFF</span>
              <span class="checkbox-on">ON</span>
            </div>
          </div>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row class="mt-3">
      <b-col class="col-xl-2 col-md-12 align-self-center">
        <strong>메소드명</strong>
      </b-col>
      <b-col class="col-xl-5 col-md-12 d-flex align-self-center">
        <span>
          <strong>IP Address(한 행에 한개씩)</strong>
          <br>
          <small class="text-danger">아이피를 정의하면 해당 아이피에만 적용됩니다</small>
        </span>
      </b-col>
      <b-col class="col-xl-2 col-md-12 align-self-center">
        <strong>차단 모드</strong>
      </b-col>
      <b-col class="col-xl-3 col-md-12 align-self-center">
        <strong>방화벽 모드에 따라 동작</strong>
      </b-col>
    </b-row>
    <hr>
    <b-row v-for="(m, index) in method_list" :key="'_method_'+index">
      <b-col class="col-xl-2 col-md-12 align-self-center">
        {{ m.method.toUpperCase() }}
      </b-col>
      <b-col v-if="m" class="col-xl-5 col-md-12 align-self-center mt-3">
        <b-form-textarea @update="update($event, m.method, 'ip_list')" id="ph_content" v-model="m.ip_list" :max-rows="50" :disabled="method_lock"></b-form-textarea>
      </b-col>
      <b-col class="col-xl-2 col-md-12 align-self-center">
        <b-form-group>
          <div class="checkbox-switch">
            <input type="checkbox" class="input-checkbox" name="switch06" id="switch06" :disabled="m.is_mode" color="danger" label variant="pill" size="sm" defaultChecked v-model="m.is_block" @change="update($event, m.method, 'is_block')">
            <div class="checkbox-animate disabled">
              <span class="checkbox-off">OFF</span>
              <span class="checkbox-on">ON</span>
            </div>
          </div>
        </b-form-group>
      </b-col>
      <b-col v-if="m" class="col-xl-3 col-md-12 align-self-center">
        <b-form-group>
          <div class="checkbox-switch">
            <input type="checkbox" class="input-checkbox" name="switch06" id="switch06" color="primary" label variant="pill" size="sm" defaultChecked v-model="m.is_mode" @change="update($event, m.method, 'is_mode')" :disabled="method_lock">
            <div class="checkbox-animate disabled">
              <span class="checkbox-off">OFF</span>
              <span class="checkbox-on">ON</span>
            </div>
          </div>
        </b-form-group>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import App from './app.js'; export default Object.assign({}, App);
</script>
